export function exitEditMode(block: HTMLElement) {
	const findHtmlEl = pm.utils.dom.findHtmlEl;

	block.classList.remove("is-editing");

	const triggerButtonsWrapper = findHtmlEl(block, ".trigger-buttons");
	triggerButtonsWrapper?.classList.remove("is-hidden");

	const actionButtonsWrapper = findHtmlEl(block, ".action-buttons");
	actionButtonsWrapper?.classList.add("is-hidden");

	const errorMessageEl = findHtmlEl(block, ".wpbf-notice-error");
	if (errorMessageEl) errorMessageEl.classList.add("is-hidden");

	const contentWrapper = findHtmlEl(block, ".content-wrapper");
	if (contentWrapper) contentWrapper.classList.remove("is-hidden");

	const editor = findHtmlEl(block, ".content-editor");
	if (editor) editor.classList.add("is-hidden");

	const suffixEl = findHtmlEl(block, ".field-suffix");
	if (suffixEl) suffixEl.classList.add("is-hidden");
}

/**
 * Exit edit modes for all blocks.
 *
 * If you want to exclude a block from the process,
 * then provide it as `blockToSkip`.
 *
 * @param blockToSkip
 */
export function exitAllEditModesExcept(blockToSkip?: HTMLElement) {
	const blocks = pm.utils.dom.findHtmlEls(".inline-editing");
	if (!blocks.length) return;

	blocks.forEach(function (block) {
		if (blockToSkip && blockToSkip == block) return;
		exitEditMode(block);
	});
}
